export default __webpack_public_path__ + "static/media/safety-icon.25f77fce.svg";